<script lang="ts">
	import type { IArticle } from 'customTypes/news';
	import UpdateNews from 'assets/svg/updateNews.svg?component';
	import { timeSince } from 'utils/SocialNetworksUtils/DateTools/DateTools';
	import { htmlRegex } from 'utils/regex/html.js';

	export let dark = false;
	export let list: IArticle[];
	export let isNewsPage = false;
	export let onUpdate: () => void = () => {};
	export let withUpdateOption = true;
</script>

<div
	class="outer-scrollbar"
	class:wrap-height={!isNewsPage}
	class:dark
	class:invisible={list.length < 1}
>
	<div class="news-list">
		{#if withUpdateOption}
			<div class="update-news" class:showMobile={isNewsPage} on:click={onUpdate}>
				<UpdateNews width={15} height={12} class="update-icon" />
				<h3 class="update-text">News</h3>
			</div>
		{/if}

		{#if list.length < 1}
			<p class="no-news">No news</p>
		{/if}

		<ul class="list">
			{#each list as item}
				<li class="list-item">
					<a href={item.url} target="#">
						<h3 class="list-item-title">{item.title}</h3>
					</a>
					<p class="list-item-text">{item.description?.replace(htmlRegex, '').substring(0, 130) + '...'}</p>
					<div class="info">
						<a href={item.url} target="#" class="link">Read more</a>
						{#if item.source}
							<p class="source">
								{item.source}
								<span class="time"> &middot {timeSince(new Date(item.published_at))}</span>
							</p>
						{/if}
					</div>
				</li>
			{/each}
		</ul>
	</div>
</div>

<style lang="scss">
	@import 'newsList';
</style>
